/* eslint-disable */

export enum SearchIndex {
  JOBS = 0,
  UNRECOGNIZED = -1,
}

export interface CrawlRequest {
  index: SearchIndex;
}
